module.exports = __webpack_public_path__ + "static/media/video.dc253261.webm";